import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterceptorProviders } from '../interceptors';
import { ClientService } from '../client/client.service';
import { WebClientService } from '../client/web-client.service';
import { ApiUserService } from './api-user/api-user.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers:[
    InterceptorProviders,
    ClientService,
    WebClientService,
    ApiUserService,
  ]
})
export class ApiModule { }
